/**
 * Runs one telemetry call so that it can never break the caller (DHT-5398
 * AC10): a synchronous throw is swallowed, and so is a returned promise that
 * rejects, so nothing surfaces as an unhandled rejection either.
 *
 * The SDKs do both. Native calls reject when the SDK is not initialised, and
 * throw when the native module is missing from a build (DHT-4542); the web SDK
 * throws if it is half-loaded. A payment, a video call or a login must render
 * whatever telemetry is doing.
 */
export const guard = (call: () => unknown): void => {
  try {
    const result = call();
    if (
      result != null &&
      typeof (result as { catch?: unknown }).catch === "function"
    ) {
      (result as Promise<unknown>).catch(() => {});
    }
  } catch {
    // Telemetry is never worth an error of its own.
  }
};
